export class Users {
    static readonly AUTHENTICATE_USERS_USING_CURRENT_TOKEN =
        '/api/Users/httpPost_AuthenticateUserUsingCurrentToken';
    static readonly AUTHENTICATE_USER_USING_SSO =
        '/api/Users/httpPost_AuthenticateUserUsingSSO';
    static readonly GET_USER_ADMIN_MODELS_USING_ID =
        '/api/Users/httpGet_GetUserAdminModelsUsingID';
    static readonly GET_USER_LOGS_USING_EMAIL =
        '/api/Users/httpGet_GetUserLogsUsingEmail';
    static readonly GET_USER_OPS_LOG_ENTRIES_USING_CURRENT_TOKEN =
        '/api/Users/httpGet_GetUserOpsLogEntriesUsingCurrentToken';
    static readonly GET_USER_IMPERSONATABLES_USING_EMAIL =
        '/api/Users/httpGet_GetUserImpersonatablesUsingEmail';
    static readonly UPDATE_USER_DEFAULT_REPORT_USING_CURRENT_TOKEN =
        '/api/Users/httpPost_UpdateUserDefaultReportUsingCurrentToken';
    static readonly UPDATE_USER_PASSWORD_USING_CURRENT_TOKEN =
        '/api/Users/httpPost_UpdateUserPasswordUsingCurrentToken';
    static readonly DEAUTHENTICATE_USER_USING_CURRENT_TOKEN =
        '/api/Users/httpGet_DeauthenticateUserUsingCurrentToken';
    static readonly GET_USER_MODEL_BY_USER_ID = 
        '/api/Users/httpGet_GetUserModelUsingID';
}

export default Users;
